import { ACTIONS, KEYS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces'

export interface UserReducerI {
    token_type: string | null
    scope: string | null
    expires_in: number | null
    ext_expires_in: number | null
    access_token: string | null
    refresh_token: string | null
    first_name: string | null
    last_name: string | null
    email: string | null
    usage_reason: string | null
    user_literal: string | null
    username: string | null
    zones: string[]
    business_functions: string[]
    countries: string[]
    roles: string[]
    user_workspace_details: string | null
    is_business_owner?: boolean
}

export interface UserReducer {
    user: UserReducerI | null
    accessToken: string | null
    refreshToken: string | null
    isAuthenticated: boolean
    permissions: any
}

const initialState: UserReducer = {
    user: null,
    accessToken: null,
    refreshToken: null,
    isAuthenticated: false,
    permissions: null,
}

const userReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.USER.LOGIN:
            return {
                ...state,
                user: action.payload.user,
                accessToken: action.payload.accessToken ?? localStorage.getItem(KEYS.AUTH_ACCESS),
                refreshToken: action.payload.refreshToken ?? localStorage.getItem(KEYS.AUTH_REFRESH),
                isAuthenticated: true,
                permissions: action.payload.permissions,
            }

        case ACTIONS.USER.USER:
            return {
                ...state,
                user: action.payload,
            }
        case ACTIONS.USER.UPDATE_USER: {
            return { ...state, user: { ...state.user, ...action.payload.user } }
        }

        case ACTIONS.USER.LOGOUT:
            return {
                ...state,
                user: null,
                accessToken: null,
                refreshToken: null,
                isAuthenticated: false,
                permissions: null,
                workers: null,
                loader: null,
            }
        default:
            return state
    }
}

export default userReducer
